<template>
  <div v-show="isActive">
    <slot></slot>
  </div>
</template>

<script>
import { unref } from "vue";

export default {
  name: "ContentTab",
  props: ["title"],
  inject: ["selectedTab"],
  computed: {
    isActive() {
      return this.title === unref(this.selectedTab);
    },
  },
};
</script>
